<div class="container actionsTop col-12">
  <!-- <button pButton type="button" (click)="showModalProfissionais = true" label="Filtros"></button> -->

  <div class="btns-actions">
    <button pButton type="button" (click)="showModalProfissionais = true" class="btn-filter">
      <i class="pi pi-search"></i>
      Filtros
    </button>

    <div *ngIf="totalProfissionais > 0">
      <button type="button" class="btn-exportar pdf" (click)="downloadPDFProfissional()">
        <i class="pi pi-file-pdf"></i>
        Exportar Relatório PDF
      </button>
      <button type="button" class="btn-exportar excel p-button-success" (click)="downloadExcelProfissional()">
        <i class="pi pi-file-excel"></i>
        Exportar Relatório Excel
      </button>
    </div>
  </div>


  <div class="data-filter mt-3" *ngIf="totalProfissionais > 0">
    <div class="flex justify-content-between align-items-center w-full">
      <span class="fw-bold">
        {{ totalProfissionais }} Profissionais encontrados
        <span class="text-500 font-normal ml-2" *ngIf="pagination.totalPages && pagination.totalPages > 1">
          (Página {{ pagination.pageNumber }} de {{ pagination.totalPages }})
        </span>
      </span>
    </div>
    <article *ngIf="appliedFiltersProfissionais.length > 0">
      <p>Filtros Aplicados</p>
      <div class="filter">
        <span *ngFor="let filter of appliedFiltersProfissionais">{{filter.label}}: {{filter.value}} </span>
      </div>
    </article>
  </div>

  <app-table class="w-100" *ngIf="totalProfissionais > 0" [pagination]="pagination" [columns]="columnsProfissionais"
    (pageChange)="onPageChange($event)">
  </app-table>

  <div class="flex flex-column align-items-center justify-content-center p-5 w-full" *ngIf="carregando">
    <i class="pi pi-spin pi-spinner text-primary" style="font-size: 2.5rem"></i>
    <span class="mt-3 text-600 font-medium">A consultar profissionais e a gerar relatório...</span>
  </div>

  <div class="no-data w-full" *ngIf="totalProfissionais === 0 && !carregando">
    <app-data-void titulo="Nenhum registro encontrado"
      descricao="Clique em filtros e aplique um filtro para iniciar"></app-data-void>
  </div>
</div>


<p-dialog header="Filtros de Profissionais" [draggable]="false" [modal]="true" [(visible)]="showModalProfissionais"
  [style]="{ width: '40rem' }" [closable]="true">

  <form [formGroup]="formProfissional" class="SetBorder">
    <div class="p-fluid grid">
      <div class="field col-12 d-flex flex-column">
        <label for="titulo">Tipo de Relatório</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="titulo" formControlName="titulo"
          [options]="titlleOptions" optionLabel="label" optionValue="value" placeholder="Seleccione o título"
          class="w-full"></p-select>
        <small class="error-message"
          *ngIf="formProfissional.get('titulo')?.invalid && formProfissional.get('titulo')?.touched">
          O tipo do relatório é obrigatório.
        </small>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="subsector">Subsector</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="subsector" formControlName="subsector"
          [options]="subSectorList" optionLabel="label" optionValue="value" placeholder="Seleccione o subsector"
          class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="ProfissaoReferencia">Profissão de Referência</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="ProfissaoReferencia"
          formControlName="ProfissaoReferencia" [options]="profissaoList" optionLabel="label" optionValue="label"
          placeholder="Seleccione a profissão de referência" class="w-full">
        </p-select>
      </div>

      <div class="field col-6 d-flex flex-column">
        <label for="especialidade">Especialidade</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="especialidade" formControlName="especialidade"
          [options]="especialidadeList" optionLabel="label" optionValue="label" placeholder="Seleccione a especialidade"
          class="w-full">
        </p-select>
      </div>

      <div class="field col-6 d-flex flex-column">
        <label for="grupWork">Grupo de Trabalho</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="grupWork" formControlName="grupWork"
          [options]="groupPersonList" optionLabel="label" optionValue="value" placeholder="Seleccione o grupo"
          class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="regime">Regime de Trabalho</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="regime" formControlName="regime"
          [options]="regimeList" optionLabel="label" optionValue="id" placeholder="Seleccione o regime" class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="habilitacaoAcademica">Habilitações Académicas</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="habilitacaoAcademica"
          formControlName="habilitacaoAcademica" [options]="habilitacaoList" optionLabel="label" optionValue="id"
          placeholder="Seleccione a habilitação" class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="anoExperiencia">Experiência Profissional</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="anoExperiencia"
          formControlName="anoExperiencia" [options]="experienciaList" optionLabel="label" optionValue="id"
          placeholder="Seleccione os anos de Experiência" class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="genero">Género</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="genero" formControlName="genero"
          [options]="generoOptions" optionLabel="label" optionValue="value" placeholder="Seleccione o género"
          class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="idadeMinima">Idade Mínima</label>
        <p-inputnumber id="idadeMinima" class="w-full" [showButtons]="true" formControlName="idadeMinima" [min]="18"
          [max]="32" placeholder="Informe a idade mínima"></p-inputnumber>
      </div>

      <div class="field col-6 d-flex flex-column">
        <label for="idadeMaxima">Idade Máxima</label>
        <p-inputnumber id="idadeMaxima" class="w-full" [showButtons]="true" formControlName="idadeMaxima" [min]="18"
          [max]="32" placeholder="Informe a idade máxima"></p-inputnumber>
      </div>

      <div class="col-12">
        <small *ngIf="formProfissional.errors?.['idadeInvalida']" class="error-message">
          A idade mínima não pode ser maior que a idade máxima.
        </small>
      </div>

      <div class="field col-6 d-flex flex-column">
        <label for="empresaid">Empresa do sector</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="empresaid" formControlName="empresaid"
          [options]="empresaSectorList" optionLabel="label" optionValue="value" placeholder="Seleccione a empresa"
          class="w-full">
        </p-select>
      </div>
      <div class="field col-6 d-flex flex-column">
        <label for="IsEmpregado">Empregado?</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="IsEmpregado" formControlName="IsEmpregado"
          [options]="estadoProfissionalList" optionLabel="label" optionValue="id" placeholder="Seleccione a resposta"
          class="w-full">
        </p-select>
      </div>
      <div class="field col-12 d-flex flex-column">
        <label for="estadoCandidatura">Estado da Candidatura</label>
        <p-select [filter]="true" [showClear]="true" appendTo="body" id="estadoCandidatura"
          formControlName="estadoCandidatura" [options]="estadoCAndidaturaList" optionLabel="label" optionValue="id"
          placeholder="Seleccione o estado" class="w-full">
        </p-select>
      </div>

    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-between align-items-center w-full flex-wrap gap-2">
      <button
        pButton
        type="button"
        label="Limpar Filtros"
        icon="pi pi-filter-slash"
        severity="secondary"
        [text]="true"
        (click)="limparFiltrosProfissionais()">
      </button>

      <div class="flex gap-2 flex-wrap">
        <button
          pButton
          type="button"
          label="Cancelar"
          icon="pi pi-times"
          severity="secondary"
          [outlined]="true"
          (click)="showModalProfissionais = false">
        </button>

        <button
          pButton
          type="button"
          label="Emitir PDF"
          icon="pi pi-file-pdf"
          class="p-button-danger p-button-outlined"
          (click)="emitirPdfComFiltros()">
        </button>

        <button
          pButton
          type="button"
          label="Emitir Excel"
          icon="pi pi-file-excel"
          class="p-button-success p-button-outlined"
          (click)="emitirExcelComFiltros()">
        </button>

        <button
          pButton
          type="button"
          label="Emitir Relatório"
          icon="pi pi-check"
          [loading]="carregando"
          (click)="onSubmitProfissional()">
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-toast />
